<form [formGroup]="formGroup" class="eq5d">
  @for (element of elements; track element.name; let i = $index) {
    @if (element.type === "radiogroup") {
      <div class="eq5d-row">
        <div class="eq5d-q">
          <div class="eq5d-q-title">
            <span>{{ i + 1 }}. {{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="eq5d-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>
        <div class="eq5d-a">
          <div class="eq5d-group">
            @for (choice of element.choices; track choice.value) {
              <label class="eq5d-option">
                <input
                  type="radio"
                  [formControlName]="element.name"
                  [value]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                />
                <span class="eq5d-option-text">{{
                  choice.text
                }}</span>
              </label>
            }
          </div>
        </div>
      </div>
    }
    @if (element.type === "text") {
      <div class="eq5d-vas">
        <div class="eq5d-vas-instructions">
          <p>{{ "EQ5D_VAS_Intro" | translate }}</p>
          <p>{{ "EQ5D_VAS_Scale" | translate }}</p>
          <p>{{ "EQ5D_VAS_Anchor" | translate }}</p>
          <p>{{ "EQ5D_VAS_WriteNumber" | translate }}</p>
        </div>
        <div class="eq5d-vas-input-row">
          <label class="eq5d-vas-label" [attr.for]="element.name">{{
            element.title
          }}</label>
          <input
            [id]="element.name"
            type="number"
            min="0"
            max="100"
            class="eq5d-vas-input"
            [formControlName]="element.name"
          />
        </div>
      </div>
    }
  }
</form>